<template>
  <nav
    :id="navId"
    class="nav-anchors"
    :class="[
      size,
      { 'nav-pills': pills, },
    ]"
  >
    <ul>
      <!-- TODO: refacto pour ne passer qu'un tableau au lieu d'un second composant (comme pour les Tabs) -->
      <li
        v-for="title in navTitles"
        :key="title.anchorId"
      >
        <Anchor
          :label="title.label"
          :anchor-id="`#${title.anchorId}`"
        >
          <template
            v-if="title.icon"
            #icon
          >
            <component :is="title.icon" />
          </template>
        </Anchor>
      </li>
    </ul>
  </nav>
</template>

<script>
import Anchor from "../../components/nav/Anchor.vue";

/**
 * Définit un groupe d'ancres.
 */
export default {
  name: "AnchorsGroup",
  components: {
    Anchor,
  },
  props: {
    /**
     * Titres de la page. L'élément actif sera celui sur lequel l'utilisateur se trouve.
     * Il change donc selon la position du scroll dans la page.
     */
    navTitles: {
      type: Array,
      default: () => [],
    },
    /**
     * Identifiant HTML de la balise contenant les ancres.
     */
    navId: {
      type: String,
      required: true,
    },
    /**
     * Taille globale.
     */
    size: {
      type: String,
      validator: (value) => ["small", "medium", "large"].includes(value),
      default: "medium",
    },
    /**
     * Définit une apparence alternative (bordure, fond...).
     */
    pills: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss"></style>
